import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { SuccessOutline, CopyOutline } from '@olist/design-system-icons';
import ButtonWrapper from './styles.js';
import { useCopyWithDelay } from '../../hooks/useCopy.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const CopyButton = (_a) => {
    var { tooltipText, valueToCopy } = _a, props = __rest(_a, ["tooltipText", "valueToCopy"]);
    const { hasCopied, handleCopy } = useCopyWithDelay(valueToCopy);
    const component = (React.createElement(ButtonWrapper, Object.assign({ onClick: handleCopy, copied: hasCopied, variation: "secondary", "data-testid": "copy-button" }, props), hasCopied ? (React.createElement(SuccessOutline, { "data-testid": "success-icon" })) : (React.createElement(CopyOutline, { "data-testid": "copy-icon" }))));
    return tooltipText ? (React.createElement(Tooltip, { content: tooltipText }, component)) : (component);
};

export { CopyButton };
